<template>
  <div class="report-wrapper-full-width">
    <div class="tabs-container">
      <div
        class="tab"
        :class="{ 'active': activeTab === 'ReportSummary' }"
        @click="changeTab('ReportSummary')"
      >
        Report Summary
      </div>
      <div
        class="tab"
        :class="{ 'active': activeTab === 'VoyageReport' }"
        @click="changeTab('VoyageReport')"
      >
        Voyage Report
      </div>
      <div
        class="tab"
        :class="{ 'active': activeTab === 'Datalog' }"
        @click="changeTab('Datalog')"
      >
        Datalog
      </div>
      <div
        class="tab"
        :class="{ 'active': activeTab === 'CustomChart' }"
        @click="changeTab('CustomChart')"
      >
        Custom Chart
      </div>
      <div
        class="tab"
        :class="{ 'active': activeTab === 'TeltonikaMap' }"
        @click="changeTab('TeltonikaMap')"
        v-if="hasTeltonikaAccess"
      >
        Teltonika Map
      </div>
    </div>

    <div class="tab-content">
      <div v-if="activeTab === 'ReportSummary'">
        <report-summary />
      </div>
      <div v-if="activeTab === 'VoyageReport'">
        <voyage-report />
      </div>
      <div v-if="activeTab === 'Datalog'">
        <fms-datalog />
      </div>
      <div v-if="activeTab === 'CustomChart'">
        <chart-report />
      </div>
      <div v-if="activeTab === 'TeltonikaMap' && hasTeltonikaAccess">
        <teltonika-map />
      </div>
    </div>
  </div>
</template>

<script>
import ReportSummary from '@/views/report/FmsReport.vue';
import VoyageReport from '@/views/voyage_report/Index.vue';
import FmsDatalog from '@/views/report/FmsReportDatalog.vue';
import TeltonikaMap from '@/views/map/TeltonikaMap.vue';
import ChartReport from '@/views/report/ChartReport.vue';

export default {
  name: 'ReportWrapper',
  components: {
    ReportSummary,
    VoyageReport,
    FmsDatalog,
    TeltonikaMap,
    ChartReport,
  },
  computed: {
    // Mengambil state tab aktif dari URL sebagai "single source of truth"
    activeTab() {
      const menu = this.$route.query.menu;
      const validTabs = ['ReportSummary', 'VoyageReport', 'Datalog', 'CustomChart'];

      if (this.hasTeltonikaAccess) {
        validTabs.push('TeltonikaMap');
      }

      // Jika menu di URL valid, gunakan itu. Jika tidak, gunakan default.
      if (menu && validTabs.includes(menu)) {
        return menu;
      }

      return 'ReportSummary'; // Tab default
    },
    // Computed property untuk membersihkan duplikasi logika di template
    hasTeltonikaAccess() {
      return this.userAccess && this.userAccess.teltonika_map && this.userAccess.teltonika_map.find((x) => x === 'read');
    },
  },
  methods: {
    // Method ini dipanggil saat tab diklik
    changeTab(tabName) {
      // Hanya update URL jika tab yang diklik berbeda dengan yang aktif
      if (this.activeTab !== tabName) {
        this.$router.push({ query: { menu: tabName } }).catch((err) => {
          // Mengabaikan error "NavigationDuplicated" yang wajar terjadi
          if (
            err.name !== 'NavigationDuplicated'
            && !err.message.includes('Avoided redundant navigation')
          ) {
            console.error(err);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.report-wrapper-full-width {
  width: 100%;
}

.tabs-container {
  display: flex;
  border-bottom: 2px solid #e0e0e0;
  width: 100%;
}

.tab {
  padding: 10px 18px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  position: relative;
  transition: color 0.3s ease;
}

.tab:not(:last-child) {
  margin-right: 12px;
}

.tab:hover {
  color: #ff69b4;
}

.tab.active {
  color: #ff69b4;
  font-weight: 600;
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #ff69b4;
  border-radius: 2px;
}
</style>
